export default __webpack_public_path__ + "static/media/STRIP.a0048d55.png";